const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_KONGCHOU_WF10011: {
						name: ['(客製)請假提出核准天數設定','(Customize)Leave Approval Days','(客制)请假提出核准天数设定'],
						url: '/zz_kongchou_wf10011',
						hint: [],
					},
					ZZ_PADAUK_WF10010: {
						name: ['(客製)請假不合併計算假勤設定','(Customize)Not Combine Calculate Leave','(客制)请假不合并计算假勤设定'],
						url: '/zz_padauk_wf10010',
						hint: [],
					},
					ZZ_KONGCHOU_WF10020: {
						name: ['(客製)加班單次數限制設定','(Customize)Overtime Limit','(客制)加班单次数限制设置'],
						url: '/zz_kongchou_wf10020',
						hint: [],
					},
				},
			}
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};